package com.appcreator.blueprint.spec

class ActionBuilderProvider(
    val block: () -> ActionBuilder
)